(function ($, Drupal, window, document) {
  'use strict';

  Drupal.behaviors.all_news = {
    attach: function all_news(context, settings) {

      if (typeof context['location'] !== 'undefined') {

        // On ajax reload, set the default view
        $(document).ajaxComplete(function () {
          // Make sure view is scrollable (mobile only)
          $('body').removeClass('no-scroll');
        });

        // Toggle mobile filters
        $('body').on('click', '.news__tray-toggle', function (e) {
          // Toggle tray menu
          const isOpen = $('.fieldset__view-filters.tray').hasClass('active');

          // Toggle view
          (isOpen) ? closeFilters() : openFilters();
        });

        $('body').on('click', '.news__tray-toggle.filters', function (e) {
          $('.fieldset__view-filters.tray').addClass('filters-open');
        });

        $('body').on('click', '.news__tray-toggle.search', function (e) {
          $('.fieldset__view-filters.tray').addClass('search-open');
        });

        const openFilters = () => {
          // Open filter panel
          $('.fieldset__view-filters.tray')
            .addClass('active')
            .attr('aria-hidden', 'false');

          $('body').addClass('no-scroll');
        }

        const closeFilters = () => {
          // Close filter panel
          $('.fieldset__view-filters.tray')
            .removeClass('active filters-open search-open')
            .attr('aria-hidden', 'true');

          $('body').removeClass('no-scroll');
        }
      }
    }
  };

})(jQuery, Drupal, window, document);
